<template>
  <ModalOperator class="no-border" :width="330" type="primary" iconType="md-settings" iconSize="18" text="微信绑定" title="微信绑定" :customButton=true>
    <div id="login_container">正在生成二维码，请稍后</div>
  </ModalOperator>
</template>
<script>
import ModalOperatorMixin from '@/components/commons/ModalOperatorMixin'
import {getCurrentuser} from '@/api/login'

export default {
  name: 'WxBind',
  mixins: [ModalOperatorMixin],
  methods: {
    async beforeOpen() {
      let _currentuser = await getCurrentuser()
      this.handleBindWeixin(_currentuser.userInfo.loginName)
    },
    handleBindWeixin(loginName) {
      var returnUrl = encodeURIComponent(window.location.href);
      var tourl = encodeURIComponent('https://www.czcycx.com' + '/api/zcfw/wxopen/wx_scan_bind?loginName=' + loginName + '&returnUrl=' + returnUrl)
      setTimeout(() => {
        /* eslint-disable no-new */
        new WxLogin({
          id: 'login_container',
          appid: 'wxde44c4568f9422fc',
          scope: 'snsapi_login',
          redirect_uri: tourl,
          // redirect_uri: encodeURIComponent(
          //   'http://wxgw.980512.com/wxopen_oauth_callback.html?tourl=' + tourl
          // ),
          state: Math.ceil(Math.random() * 10000),
          style: 'black',
          href: ''
        });
      }, 2000);
    }
  },
  mounted() {
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js?';
    document.body.appendChild(s);
  }
};
</script>
<style scoped>
.no-border.ivu-btn{
  border: 1px solid transparent;
}
</style>
